export const EVENTS_CARD_VES = 'eventsCardVES';

export const EVENTS_CARD_VES_ACTIONS_NAME = {
  getEventCard: `${EVENTS_CARD_VES}/getEventCard`,
};

export const EVENTS_CARD_VES_MUTATIONS_NAME = {
  setEventCard: `${EVENTS_CARD_VES}/setEventCard`,
};

export const EVENTS_CARD_VES_GETTERS_NAME = {
  getEventCard: `${EVENTS_CARD_VES}/getEventCard`,
};
